import { useState, useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import { eachMonthOfInterval, format, subYears, addYears } from 'date-fns';

import { getDinnerReservations } from '@/api/getDinnerReservations';
import Breadcrumbs, { BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';
import DinnerReservationDetails from '@/components/reservations/dinner/DinnerReservationDetails';
import { NavigationButtons } from '@/components/reservations/NavigationButtons';
import SelectField from '@/components/SelectField/SelectField';
import { DinnerReservation } from '@/types/dinner';

import 'react-datepicker/dist/react-datepicker.css';

const DinnerReservationsPage = () => {
  const { pathname: pathName } = useLocation();
  const breadcrumbs: BreadcrumbItem[] = [{ path: pathName, name: '夕食予約一覧' }];
  const email = localStorage.getItem('email') || '';

  const { control, setValue, getValues } = useForm<{ yearMonth: string }>();
  const watchValues = useWatch({ control, name: ['yearMonth'] });
  const [reservations, setReservations] = useState<DinnerReservation[]>([]);

  const getYearMonths = () => {
    const yearMonths = eachMonthOfInterval({
      start: subYears(new Date(), 1),
      end: addYears(new Date(), 1),
    });
    return yearMonths.map((yearMonth) => ({
      value: format(yearMonth, 'yyyy-MM'),
      label: format(yearMonth, 'yyyy年MM月'),
    }));
  };

  useEffect(() => {
    const currentYearMonth = format(new Date(), 'yyyy-MM');
    setValue('yearMonth', currentYearMonth);
  }, [setValue]);

  useEffect(() => {
    if (!watchValues || !watchValues[0]) return;
    const [year, month] = watchValues[0].split('-');
    const fetchDinnerReservations = async () => {
      const result = await getDinnerReservations(email, parseInt(year, 10), parseInt(month, 10));
      if (result.status === 200) {
        setReservations(result.result);
      }
    };
    fetchDinnerReservations();
  }, [watchValues]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Breadcrumbs item={breadcrumbs} />
      </div>
      <NavigationButtons />
      <div className="mt-5 flex flex-col gap-4 bg-white">
        <div className="flex w-40 flex-row">
          <SelectField
            name="yearMonth"
            control={control}
            items={getYearMonths()}
            defaultValue={format(new Date(), 'yyyy-MM')}
          />
        </div>

        <div className="w-full">
          <DinnerReservationDetails
            yearMonth={getValues('yearMonth') || ''}
            reservations={reservations}
          />
        </div>
      </div>
    </div>
  );
};

export default DinnerReservationsPage;
